import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import { DEBUG_STORE_KEY } from '@/features/experiments/constants/store';

export type DebugStore = {
  debugMessage?: string;
  updateDebugMessage: (message?: string) => void;
};

export const useDebugStore = create<DebugStore>()(
  persist(
    (set) => ({
      debugMessage: undefined,
      updateDebugMessage: (message?: string) => {
        set({ debugMessage: message });
      }
    }),
    {
      name: DEBUG_STORE_KEY,
      storage: createJSONStorage(() => storage)
    }
  )
);
